"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseValuesFromRawOplusTime = parseValuesFromRawOplusTime;
const common_1 = require("../../common/common");
const legacyVariableNames_1 = __importDefault(require("../plan/legacyVariableNames"));
const planValue_1 = require("../../model/v2/planValue");
const periodTypes_1 = __importDefault(require("../../table/v1/periodTypes"));
const table_1 = require("../../table/v1/table");
const timeZones_1 = __importDefault(require("../../common/timeZones"));
function parseValuesFromRawOplusTime(r) {
    const oplusDate = new Date(r.dateOplusTime);
    const realDate = (0, common_1.fromOplusTime)(oplusDate);
    const valuesOut = [];
    if (r.revenue) { // Disallow zero
        const revValueReq = {
            id: 0,
            functionId: 0,
            startDate: realDate,
            endDate: (0, table_1.endDateForPeriod)(realDate, periodTypes_1.default.DAY, timeZones_1.default.ASIA_TOKYO),
            functionBody: r.revenue.toString(),
        };
        const revValOpt = {
            value: r.revenue,
            feFunctionId: legacyVariableNames_1.default.REVENUE,
            feId: `${r.branchID}-${legacyVariableNames_1.default.REVENUE}-${revValueReq.startDate.toISOString()}-${revValueReq.endDate.toISOString()}`
        };
        const revenueValue = new planValue_1.PlanValue(revValueReq, revValOpt);
        valuesOut.push(revenueValue);
    }
    if (r.staffNum) {
        let isDailyArray = false;
        if (r.staffNum.length > 1) {
            isDailyArray = true;
        }
        let period = periodTypes_1.default.DAY;
        if (isDailyArray) {
            period = periodTypes_1.default.HOUR;
        }
        r.staffNum.forEach((s, i) => {
            if (!s) { // Disallow zero
                return;
            }
            const date = new Date(realDate.valueOf() + (3600000 * i));
            const req = {
                id: 0,
                functionId: 0,
                startDate: date,
                endDate: (0, table_1.endDateForPeriod)(date, period, timeZones_1.default.ASIA_TOKYO),
                functionBody: s.toString(),
            };
            const op = {
                value: s,
                feFunctionId: legacyVariableNames_1.default.CUSTOMERS,
                feId: `${r.branchID}-${legacyVariableNames_1.default.CUSTOMERS}-${req.startDate.toISOString()}-${req.endDate.toISOString()}`
            };
            const value = new planValue_1.PlanValue(req, op);
            valuesOut.push(value);
        });
        if (!isDailyArray && r.staffNum[0]) {
            const s = r.staffNum[0]; // Make 24 hourly values using the same number value as daily
            for (let i = 0; i < 24; i++) {
                const date = new Date(realDate.valueOf() + (3600000 * i));
                const req = {
                    id: 0,
                    functionId: 0,
                    startDate: date,
                    endDate: (0, table_1.endDateForPeriod)(date, periodTypes_1.default.HOUR, timeZones_1.default.ASIA_TOKYO),
                    functionBody: s.toString(),
                };
                const op = {
                    value: s,
                    feFunctionId: legacyVariableNames_1.default.CUSTOMERS,
                    feId: `${r.branchID}-${legacyVariableNames_1.default.CUSTOMERS}-${req.startDate.toISOString()}-${req.endDate.toISOString()}`
                };
                const value = new planValue_1.PlanValue(req, op);
                valuesOut.push(value);
            }
        }
    }
    const memoReq = {
        id: 0,
        functionId: 0,
        startDate: realDate,
        endDate: (0, table_1.endDateForPeriod)(realDate, periodTypes_1.default.DAY, timeZones_1.default.ASIA_TOKYO),
        functionBody: "",
    };
    const memoOpt = {
        feFunctionId: legacyVariableNames_1.default.MEMO,
        strValue: r.memo,
        feId: `${r.branchID}-${legacyVariableNames_1.default.MEMO}-${memoReq.startDate.toISOString()}-${memoReq.endDate.toISOString()}`
    };
    const memo = new planValue_1.PlanValue(memoReq, memoOpt);
    valuesOut.push(memo);
    return valuesOut;
}
